export enum BrandType {
  AMEX = 'amex',
  BELMOND = 'belmond',
  ESSENTIALIST = 'essentialist',
  LATAM = 'latam',
  AIRBNB = 'airbnb',
}
